export default __webpack_public_path__ + "static/media/Taj_Mahal_in_India_-_Kristian_Bertel.d84d7532.jpg";